// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { CashRegisterFragmentFragment } from '../../fragments/generated/cash-register.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetCashRegisterQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type GetCashRegisterQueryResult = { __typename?: 'Query', getCashRegister: { __typename?: 'CashRegisterDTO', id: number, invoiceBlocks: Array<string>, ownerCorporateDataId: number, description: string, address: string, port: string | null, localAddress: string | null, username: string | null, doubleCopy: boolean, cashRegisterType: { __typename?: 'CashRegisterTypeDTO', type: Types.CashRegisterTypeEnumDto | null, paperSize: Types.CashRegisterPaperSizeEnumDto | null, manufacturer: Types.CashRegisterManufacturerEnumDto | null } } | null };

export const GetCashRegisterGql = gql`
    query GetCashRegister($id: Int!) {
  getCashRegister(id: $id) {
    ...CashRegisterFragment
  }
}
    ${CashRegisterFragmentFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCashRegisterInjectable extends Apollo.Query<GetCashRegisterQueryResult, GetCashRegisterQueryVariables> {
    override document = GetCashRegisterGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */